"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _react = _interopRequireDefault(require("react"));

var _UITextToolbarSplitSelect = _interopRequireDefault(require("UIComponents/editor/UITextToolbarSplitSelect"));

var _constants = require("../lib/constants");

var _handleListTabs = _interopRequireDefault(require("../utils/handleListTabs"));

var createListStyleOption = function createListStyleOption(_ref) {
  var style = _ref.style,
      icon = _ref.icon;
  return {
    icon: icon,
    value: style
  };
};

var getBlockStyleFromEditorState = function getBlockStyleFromEditorState(editorState) {
  return editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
};

var createListStyleDropdown = function createListStyleDropdown(options) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ListStyleDropdown, _React$Component);

    function ListStyleDropdown(props) {
      var _this;

      (0, _classCallCheck2.default)(this, ListStyleDropdown);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListStyleDropdown).call(this, props));

      _this.getIsActive = function () {
        var editorState = _this.props.editorState;
        var currentValue = _this.state.currentValue;
        var currentBlockStyle = getBlockStyleFromEditorState(editorState);
        return currentBlockStyle === currentValue;
      };

      _this.getSelectedValue = function () {
        var editorState = _this.props.editorState;
        var currentBlockStyle = getBlockStyleFromEditorState(editorState);
        var selectedOption = options.find(function (_ref2) {
          var value = _ref2.value;
          return value === currentBlockStyle;
        });
        return selectedOption ? selectedOption.value : undefined;
      };

      _this.handleStyleToggle = function () {
        var _this$props = _this.props,
            editorState = _this$props.editorState,
            onChange = _this$props.onChange;
        var currentValue = _this.state.currentValue;

        var newState = _draftJs.RichUtils.toggleBlockType(editorState, currentValue);

        onChange(_draftJs.EditorState.forceSelection(newState, newState.getSelection()));
      };

      _this.handleStyleChange = function (evt) {
        var shouldApplyNewStyle = _this.getIsActive();

        _this.setState({
          currentValue: evt.target.value
        }, function () {
          if (shouldApplyNewStyle) {
            _this.handleStyleToggle();
          }
        });
      };

      _this.state = {
        currentValue: _this.getSelectedValue() || options[0].value
      };
      return _this;
    }

    (0, _createClass2.default)(ListStyleDropdown, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var editorState = this.props.editorState;
        var newSelection = editorState.getSelection();
        var newValue = this.getSelectedValue();

        if (!newSelection.equals(prevProps.editorState.getSelection()) && newValue != null) {
          this.setState({
            currentValue: newValue
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var editorState = this.props.editorState;
        var currentValue = this.state.currentValue;
        var hasFocus = editorState.getSelection().getHasFocus();
        return _react.default.createElement(_UITextToolbarSplitSelect.default, {
          active: this.getIsActive() && hasFocus,
          onButtonClick: this.handleStyleToggle,
          onChange: this.handleStyleChange,
          options: options,
          value: currentValue
        });
      }
    }]);
    return ListStyleDropdown;
  }(_react.default.Component), _temp;
};

var _default = function _default() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$listStyles = _ref3.listStyles,
      listStyles = _ref3$listStyles === void 0 ? null : _ref3$listStyles;

  var options = [];

  if (Array.isArray(listStyles)) {
    var styles = _constants.LIST_TYPES.filter(function (style) {
      return listStyles.includes(style.style);
    });

    options.push.apply(options, (0, _toConsumableArray2.default)(styles.map(createListStyleOption)));
  } else {
    options.push.apply(options, (0, _toConsumableArray2.default)(_constants.LIST_TYPES.map(createListStyleOption)));
  }

  var dropdown = createListStyleDropdown(options);
  return (0, _draftExtend.createPlugin)({
    keyCommandListener: _handleListTabs.default,
    buttons: dropdown,
    blockToHTML: {
      blockquote: {
        start: '<blockquote>',
        end: '</blockquote>'
      },
      'code-block': {
        start: '<pre>',
        end: '</pre>'
      }
    }
  });
};

exports.default = _default;
module.exports = exports.default;